// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1u6BC","col":"styles_col__3_LOg"};